let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("43XOI")).then(() => parcelRequire('95Fn6'));